export default __webpack_public_path__ + "static/media/quick-search-img.3b8eac5b.svg";